export default __webpack_public_path__ + "static/media/detail_small_9_1.58aa5974.jpg";